import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import QuestionList from './components/QuestionList'
import { getFaqList, getNoReadReplay } from '@feedback/services/index'
import './App.scss'
// import { useRequest } from 'ahooks'
import { getTextByKey, reportFn, getLangKey } from '@feedback/utils/util'
import { getAppConfig } from '@feedback/utils/CONST'

import classNames from 'classnames'

const LIMIT = 6 //限制首页faq问题列表的数量
function App() {
  const { appid } = getAppConfig() || {}
  const headerFromApp = JSON.parse(
    sessionStorage.getItem('headerFromApp') || '{}'
  )
  // const [page, setPage] = useState<number>(1)
  // const [list, setList] = useState<any[]>([])
  const [curList, setCurList] = useState<any[]>([])
  // const { data: noReadData = {} } = useRequest(() => getNoReadReplay(), { throwOnError: true })
  const [noReadData, setNoReadData] = useState<any>({})
  const noReadReplay = async () => {
    const result = await getNoReadReplay()
    if (result?.code === 0) {
      setNoReadData(result.data)
    }
  }

  const faqList = async () => {
    let result = await getFaqList()
    if (result.code == 0) {
      if (result.data instanceof Array) {
        //data为空时会出现数据为{}的情况
        setCurList(result.data.slice(0, LIMIT))
      } else {
        setCurList([])
      }
    }
  }

  useEffect(() => {
    noReadReplay()
    faqList()
    // 获取首页列表数据后,首页加载完成，上报一次埋点
    reportFn({ parm1: 1, parm2: 5, parm6: '' })
  }, [])

  // const { run } = useRequest(getFaqList, {
  //   manual: true,
  //   throwOnError: true,
  //   onSuccess: (result) => {
  //     const { data, code } = result
  //     if (code === 0) {
  //       // setList(data)
  //       if (data instanceof Array) {
  //         //data为空时会出现数据为{}的情况
  //         setCurList(data.slice(0, LIMIT))
  //       } else {
  //         setCurList([])
  //       }

  //       // setPage((curPage) => curPage + 1)
  //     }
  //   }
  // })
  // useEffect(() => {
  //   run()
  // }, [run])

  return (
    <div className='p-index'>
      <div className='index-header'>
        <p className='question-tip'>{getTextByKey('tip question1')}</p>
        <p className='question-tip'>{getTextByKey('tip question2')}</p>
        {/* 这个问号去除 */}
        {/* <span className='question-icon' /> */}
        <span className='music-icon' />
      </div>
      <div className='index-body'>
        <QuestionList questionList={curList} />
      </div>
      <div className='footer-btn-group'>
        <Link
          to='/v1/ticketType'
          onClick={() => {
            reportFn({ parm1: 1, parm2: 3, parm6: '' })
          }}
        >
          <div className='btn btn-create'>
            <div className={getLangKey() == 'fr-FR' ? 'btn-text2' : 'btn-text'}>
              {['cm1009', 'cm1017'].includes(appid) &&
              headerFromApp?.language?.includes('fr')
                ? getTextByKey('cm1009.fr.new feedback')
                : getTextByKey('new feedback')}
            </div>
          </div>
        </Link>
        <Link
          to='/v1/questionList'
          onClick={() => {
            reportFn({ parm1: 1, parm2: 4, parm6: '' })
          }}
        >
          <div className='btn btn-toggle'>
            <div className={getLangKey() == 'fr-FR' ? 'btn-text2' : 'btn-text'}>
              {getTextByKey('more')}
            </div>
          </div>
        </Link>
      </div>
      <Link
        to='/v1/ticketList'
        onClick={() => {
          reportFn({ parm1: 1, parm2: 2, parm6: '' })
        }}
      >
        <div className='btn-entry-feedback'>
          <span className='icon' />
          {noReadData?.is_has ? <span className='no-read-count'></span> : null}
        </div>
      </Link>
    </div>
  )
}

export default App
